/**
 * Created by pajicv on 10/7/18.
 */
import React from 'react';
import ManagerSubTask from './ManagerSubTask';
import TaskTitle from './TaskTitle';
import AddSubTaskButton from './AddSubTaskButton';
import { initSubTask, initPersonaDocument, updatePersonaDocumentsTags } from '../../firebase/db';
import ManagerViewUploadedDocuments from './ManagerViewUploadedDocuments';
import { Typography, Divider } from '@material-ui/core';
import { uploadPersonaDocument } from '../../firebase/storage'

class Task extends React.Component {
    handleAddSubTaskClick = () => {
        const { task, taskId, cycleId, subTasks } = this.props;
        let name = task.name + ' ' + (Object.keys(subTasks).length + 1);
        initSubTask(taskId, cycleId, task.project, name);
    };

    handleAddDocuments = (documents, taskId, projectId, cycle, subTaskId) => {
        const { auth, project, cycleId, task } = this.props
        initPersonaDocument(documents, taskId, projectId, cycleId, subTaskId, auth.email)
            .then((documentId) => {
                uploadPersonaDocument(documentId, documents, subTaskId, cycleId)
                    .then(() => {
                        const array = [project.title, cycle.title, task.name];
                        updatePersonaDocumentsTags(documentId, array, documents.name.split('.').pop());
                    });
            });
    }

    render() {
        const { project, task, subTasks, taskId, subTaskAssigned, onTagsOpen } = this.props;
        if (!project || !task || !subTasks) return null;
        return (
            <div style={{
                width: '100%'
            }}
            >
                {/*
                <div style={{
                    fontSize: 24,
                    fontWeight: 'bold'
                }}>
                    <Typography variant="title" color="secondary" gutterBottom>{`Project: ${project.title}`}</Typography>
                    <Typography variant="title" color="secondary" gutterBottom>{`Cycle ${task.cycle.index + 1}: ${task.cycle.title}`}</Typography>
                </div>
                <Divider />
                */}
                <TaskTitle
                    taskId={taskId}
                    worker={false}
                    task={task}
                    document={task.downloadDocument}
                />
                {
                    Object.keys(subTasks || {}).map(index => (
                        <ManagerSubTask
                            subTasks={subTasks}
                            taskName={task.name}
                            key={subTasks[index].key}
                            subTaskId={subTasks[index].key}
                            projectId={task.project}
                            members={project.members}
                            taskId={taskId}
                            index={index}
                            subTaskAssigned={subTaskAssigned}
                            onTagsOpen={onTagsOpen}
                            handleAddDocuments={(accepted) => {
                                this.handleAddDocuments(accepted, taskId, task.project, task.cycle, subTasks[index].key)
                            }}
                            {...subTasks[index].value}
                        />
                    ))
                }
                <AddSubTaskButton onClick={this.handleAddSubTaskClick} />
            </div>
        );
    }
}

export default Task;



// WEBPACK FOOTER //
// ./src/components/Tasks/Task.js